// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3_N1z","rootSuccess":"CompleteLink_rootSuccess__mzQao","rootFailure":"CompleteLink_rootFailure__3FbHl","isDisabled":"CompleteLink_isDisabled__awQAz"};